/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Sifre_DegistirInputs */

const tr_faq_a_sifre_degistir = /** @type {(inputs: Faq_A_Sifre_DegistirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayarlar bölümündeki Güvenlik sayfasına gidip Şifre Değiştir butonuna tıkla. Mevcut şifreni girdikten sonra yeni şifreni belirleyebilirsin. Şifreni hatırlamıyorsan giriş ekranındaki Şifremi Unuttum bağlantısını kullanabilirsin.`)
};

const en_faq_a_sifre_degistir = /** @type {(inputs: Faq_A_Sifre_DegistirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to the Security page under Settings and click Change Password. Enter your current password and then set a new one. If you have forgotten your password, use the Forgot Password link on the login screen.`)
};

const de_faq_a_sifre_degistir = /** @type {(inputs: Faq_A_Sifre_DegistirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehe unter Einstellungen zur Seite Sicherheit und klicke auf Passwort ändern. Gib dein aktuelles Passwort ein und wähle ein neues. Falls du es vergessen hast, nutze den Link Passwort vergessen auf der Anmeldeseite.`)
};

const ru_faq_a_sifre_degistir = /** @type {(inputs: Faq_A_Sifre_DegistirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейдите на страницу Безопасность в Настройках и нажмите Изменить пароль. Введите текущий пароль, затем задайте новый. Если забыли пароль, воспользуйтесь ссылкой Забыл пароль на странице входа.`)
};

/**
* | output |
* | --- |
* | "Go to the Security page under Settings and click Change Password. Enter your current password and then set a new one. If you have forgotten your password, us..." |
*
* @param {Faq_A_Sifre_DegistirInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_sifre_degistir = /** @type {((inputs?: Faq_A_Sifre_DegistirInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Sifre_DegistirInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_sifre_degistir(inputs)
	if (locale === "de") return de_faq_a_sifre_degistir(inputs)
	if (locale === "ru") return ru_faq_a_sifre_degistir(inputs)
	return tr_faq_a_sifre_degistir(inputs)
});